import { Tooltip, TooltipContent, TooltipTrigger } from "design-system/atoms/Tooltip"
import { useCampaignTimeFrame } from "modules/campaigns/components/Detail/CampaignTimeFrameContext"
import { useTranslation } from "react-i18next"
import { GoalResponseDataSchema } from "schema"
import z from "zod"
import { PredefinedResponsesActivity } from "./PredefinedResponsesActivity"
import { PredefinedResponsesDistribution } from "./PredefinedResponsesDistribution"

type Props = {
  campaignId: string
  goal: z.infer<typeof GoalResponseDataSchema>
}

export const PredefinedGoalInsights = ({ campaignId, goal }: Props) => {
  const { t } = useTranslation()
  const { timeFrame } = useCampaignTimeFrame()

  const title = goal.displayName ?? t("insights.predefinedResponses.title")
  const description = goal.assistantInstructions

  const header = description ? (
    <Tooltip>
      <TooltipTrigger slick>
        <span className="text-md font-medium">{title}</span>
      </TooltipTrigger>
      <TooltipContent>{description}</TooltipContent>
    </Tooltip>
  ) : (
    <span className="text-md font-medium">{title}</span>
  )

  return (
    <div className="flex flex-col gap-3 w-full">
      {header}
      <div className="flex flex-col xl:flex-row w-full gap-4">
        <PredefinedResponsesDistribution
          timeFrame={timeFrame}
          campaignId={campaignId}
          goalId={goal.id}
        />
        <PredefinedResponsesActivity campaignId={campaignId} goalId={goal.id} />
      </div>
    </div>
  )
}
